import React, { useContext } from "react";
import { BusinessContext } from "../../context/BusinessContext";
import { Typography, Row, Col, Card, Tag, Result,Button } from "antd";
import moment from "moment";
import "../../assets/css/Font.css";
import "../../assets/css/Offers.css";
import aboutimg from "../../assets/images/video-cover-image-4.jpg";
import { SmileOutlined, GiftOutlined } from "@ant-design/icons";
import Loader from "../Loader/";

const { Title, Paragraph } = Typography;

const Offers = () => {
  const { businessInfo } = useContext(BusinessContext);
  const offersInfos = businessInfo?.businessInfo?.[0]?.offers_info || [];
  const couponsInfos = businessInfo?.businessInfo?.[0]?.coupons_info || [];
  const vouchersInfos = businessInfo?.businessInfo?.[0]?.vouchers_info || [];

  if (!businessInfo) {
    return <Loader />;
  }

  const noData =
    offersInfos.length === 0 &&
    couponsInfos.length === 0 &&
    vouchersInfos.length === 0;

  return (
    <>
      {/* Banner Section */}
      <div className="menuBanner">
        <img
          src={aboutimg}
          alt="Menu Banner"
          style={{ width: "100%", height: "235px", objectFit: "cover" }}
        />
        <div className="innerBannerTitle">
          <Title level={2} style={{ color: "#fff", margin: "0" }}>
            Offers & Coupons
          </Title>
        </div>
      </div>

      {/* Offers Section */}
      <div className="custom_container contactSection">
        {/* Show message if no data */}
  
  {noData && (
  <Result
    icon={<GiftOutlined style={{ fontSize: "70px", color: "#722ed1" }} />}
    title={
      <span style={{ fontWeight: "bold", fontSize: "20px", color: "#333" }}>
        🎉 No Extra Offers Available Right Now
      </span>
    }
    subTitle={
      <span style={{ fontSize: "16px", color: "#595959" }}>
        We don’t have any <b>offers</b>, <b>coupons</b>, or <b>vouchers</b> at
        the moment. <br />
        But don’t worry — <b>discounts are already applied in our menu items</b> 🍽️. <br />
        Please check back <b>soon</b> for more exciting deals!
      </span>
    }
    extra={[
      <Button type="primary" size="large" key="home" href="/">
        Back to Home
      </Button>,
    ]}
  />
)}



        {/* Current Offers */}
        {offersInfos.length > 0 && (
          <>
            <Title level={3} className="offercustomHeading" style={{ textAlign: "left", marginBottom: "15px" }}>
              Current Offers
            </Title>
            <Row gutter={[16, 24]}>
              {offersInfos.map((offer, index) => (
                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                  <Card hoverable style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <Title level={5} style={{ marginTop: "0px" }}>
                      {offer.offer_name_en}
                    </Title>
                    <Paragraph type="secondary">{offer.offer_notes_en}</Paragraph>
                    <div className="offerTags">
                      {offer.offer_valid_to && (
                        <Tag color="red">Valid Until: {moment(offer.offer_valid_to).format("MMMM D, YYYY")}</Tag>
                      )}
                      {offer.offer_order_overs && (
                        <Tag color="green">Min Order: £{offer.offer_order_overs}</Tag>
                      )}
                      {offer.offer_type === 1 ? (
                        <Tag color="blue">Discount: {offer.offer_amount}%</Tag>
                      ) : (
                        <Tag color="blue">Discount: £{offer.offer_amount}</Tag>
                      )}
                      {offer.offer_applicable_to === 0 && (
                        <Tag color="purple">Valid for Delivery & Collection</Tag>
                      )}
                      {offer.offer_applicable_to === 1 && (
                        <Tag color="purple">Valid for Delivery</Tag>
                      )}
                      {offer.offer_applicable_to === 2 && (
                        <Tag color="purple">Valid for Collection</Tag>
                      )}
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}

        {/* Coupons Available */}
        {couponsInfos.length > 0 && (
          <>
            <Title level={3} className="offercustomHeading" style={{ textAlign: "left", marginBottom: "15px" }}>
              Coupons Available
            </Title>
            <Row gutter={[16, 24]}>
              {couponsInfos.map((coupon, index) => (
                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                  <Card
                    hoverable
                    style={{
                      borderRadius: "10px",
                      overflow: "hidden",
                      textAlign: "center",
                    }}
                  >
                    <Tag
                      color="green"
                      style={{
                        fontSize: "16px",
                        padding: "5px 10px",
                        fontWeight: "bold",
                      }}
                    >
                      {coupon.coupon_code}
                    </Tag>
                    <Paragraph type="secondary" style={{ margin: "10px 0" }}>
                      {coupon.offer_notes_en}
                    </Paragraph>
                    <div className="offerTags">
                      {coupon.minimum_spend && (
                        <Tag color="blue">Min Spend: £{coupon.minimum_spend}</Tag>
                      )}
                      {coupon.offer_type === 1 ? (
                        <Tag color="red">Discount: {coupon.offer_amount}%</Tag>
                      ) : (
                        <Tag color="red">Discount: £{coupon.offer_amount}</Tag>
                      )}
                      {coupon.offer_applicable_to === 0 && (
                        <Tag color="purple">Valid for Delivery & Collection</Tag>
                      )}
                      {coupon.offer_applicable_to === 1 && (
                        <Tag color="purple">Valid for Delivery</Tag>
                      )}
                      {coupon.offer_applicable_to === 2 && (
                        <Tag color="purple">Valid for Collection</Tag>
                      )}
                    </div>
                    <Paragraph style={{ fontSize: "14px", color: "#ff4d4f" }}>
                      Expires on: {moment(coupon.offer_valid_to).format("MMMM D, YYYY")}
                    </Paragraph>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}

        {/* Current Vouchers */}
        {vouchersInfos.length > 0 && (
          <>
            <Title level={3} className="offercustomHeading" style={{ textAlign: "left", marginBottom: "15px" }}>
              Current Vouchers
            </Title>
            <Row gutter={[16, 24]}>
              {vouchersInfos.map((voucher, index) => (
                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                  <Card
                    hoverable
                    style={{ borderRadius: "10px", overflow: "hidden" }}
                    cover={
                      voucher.voucher_img ? (
                        <img
                          alt={voucher.voucher_name_en}
                          src={voucher.voucher_img}
                          style={{
                            height: "180px",
                            objectFit: "cover",
                            borderBottom: "1px solid #f0f0f0",
                            marginBottom: "15px",
                          }}
                        />
                      ) : null
                    }
                  >
                    <Title level={5} style={{ marginTop: "0px" }}>
                      {voucher.voucher_name_en}
                    </Title>
                    <Paragraph type="secondary">{voucher.offer_notes_en}</Paragraph>
                    <div className="offerTags">
                      {voucher.voucher_expire_date && (
                        <Tag color="red">Valid Until: {moment(voucher.voucher_expire_date).format("MMMM D, YYYY")}</Tag>
                      )}
                      {voucher.min_orders && (
                        <Tag color="green">Min Order: £{voucher.min_orders}</Tag>
                      )}
                      {voucher.offer_type === 1 ? (
                        <Tag color="blue">Discount: {voucher.offer_amount}%</Tag>
                      ) : (
                        <Tag color="blue">Discount: £{voucher.offer_amount}</Tag>
                      )}
                      {voucher.offer_applicable_to === 0 && (
                        <Tag color="purple">Valid for Delivery & Collection</Tag>
                      )}
                      {voucher.offer_applicable_to === 1 && (
                        <Tag color="purple">Valid for Delivery</Tag>
                      )}
                      {voucher.offer_applicable_to === 2 && (
                        <Tag color="purple">Valid for Collection</Tag>
                      )}
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}
      </div>
    </>
  );
};

export default Offers;
